<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="editRelationDialog"
    :title="$t('guardians.editRelationTitle')"
    :confirm-text="$t('common.save')"
    @confirm="handleConfirm"
  >
    <template #body>
      <div class="mb-3">
        <label class="form-label">{{ $t('guardians.guardian') }}</label>
        <input 
          type="text" 
          class="form-control" 
          :value="guardianName" 
          disabled
        />
      </div>
      
      <div class="mb-3">
        <label class="form-label">{{ $t('guardians.relation') }}</label>
        <select class="form-control" v-model="relationType">
          <option value="father">{{ $t('relations.father') }}</option>
          <option value="mother">{{ $t('relations.mother') }}</option>
          <option value="uncle">{{ $t('relations.uncle') }}</option>
          <option value="aunt">{{ $t('relations.aunt') }}</option>
          <option value="other">{{ $t('relations.other') }}</option>
        </select>
      </div>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const guardianName = ref('');
const guardianId = ref(null);
const studentId = ref(null);
const relationType = ref('father');

const open = (studentIdParam, guardian) => {
  studentId.value = studentIdParam;
  guardianId.value = guardian.id;
  guardianName.value = guardian.username;
  relationType.value = guardian.pivot.relation_type;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['update']);

const handleConfirm = () => {
  emit('update', {
    studentId: studentId.value,
    guardianId: guardianId.value,
    relationType: relationType.value
  });
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
